import { Component, OnInit, ViewChild, TemplateRef, Input, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'src/app/core/services/cookie.service';
import { AppService } from 'src/app/core/services/app.service';
import { LexTranslateService } from '@app/core/services/lex-translate.service';

@Component({
  selector: 'seb-alert-app-action',
  templateUrl: './alert-app-action.component.html',
  styleUrls: ['./alert-app-action.component.css']
})
export class AlertAppActionComponent implements OnInit {

  @ViewChild('content') content: ElementRef;

  @Input() message: string = "Sua [ação] foi executada com sucesso. Essa alteração será atualizada em suas aplicações em até 24 horas.";
  @Input() title: string = "ATENÇÃO";
  @Input() buttonMessage: string;

  modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private cookieService: CookieService,
    private appService: AppService,
    public lextranslate: LexTranslateService
  ) { }

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
    this.buttonMessage = this.lextranslate.i18n['3de96c69-705b-4017-999a-bd683f188e09']
  }

  open() {
    let { userId } = this.appService.currentUser;
    let cookieNameWithUserId = `showAlertSync-${userId}`;
    let hasCoookie = this.cookieService.getCookie(cookieNameWithUserId);

    if (!hasCoookie) {
      this.modalRef = this.modalService.open(this.content, {
        backdrop: true,
        centered: true,
        keyboard: false,
        size: 'lg',
        windowClass: 'modal-alert-app-content',
        backdropClass: 'light-blue-backdrop'
      });
    }
  }

  onCheckBoxChange(event: any) {
    if (event.target.checked) {
      let { userId } = this.appService.currentUser;
      //uma data absurda qualquer para que o cookie não expire
      let expDate = new Date(5000, 12, 31);

      /**
       * nome do cookie com o id do usuário 
       * isso garante que quando um outro usuário acesse pelo mesmo navegador a mensagem será exibida para o outro
       */
      let cookieNameWithUserId = `showAlertSync-${userId}`;

      this.cookieService.setCookie(cookieNameWithUserId, "true", expDate.toUTCString());
    }
  }

  close() {
    this.modalRef.close();
  }

}
